import { AntDesign } from "@expo/vector-icons";
import { Text, useThemeProvider } from "@towersystems/roam-common-native";
import { TerminalClosure } from "@towersystems/roam-common/lib/generated-types";
import dayjs from "dayjs";
import { startCase } from "lodash";
import { Pressable } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { moneyToFormattedString } from "../../../../utilities/money";

export interface ShiftListItemProps {
  item: TerminalClosure;
  onPress?: () => void;
}
export const dateFormat = "D MMM YYYY";
export const timeFormat = "h:mm A";

export const ShiftListItem = ({ onPress, item }: ShiftListItemProps) => {
  const { colors } = useThemeProvider();

  const closedDate = dayjs(item.terminalCloseDate).format(dateFormat);
  const closedTime = dayjs(item.terminalCloseDate).format(timeFormat);
  const openedDate = dayjs(item.terminalOpenDate).format(dateFormat);
  const openedTime = dayjs(item.terminalOpenDate).format(timeFormat);

  const formattedOpenedLabel = `Opened ${openedDate}, ${openedTime} at ${startCase(
    item.terminalName
  )}`;

  const formattedClosedLabel = `Closed ${closedDate}, ${closedTime}`;

  return (
    <Pressable onPress={onPress}>
      <View flex row style={{ justifyContent: "space-between" }}>
        <View>
          <Text
            variant="heading"
            fontWeight="medium"
          >{`${formattedClosedLabel}`}</Text>
          <Text
            variant="heading4"
            color="subdued"
          >{`${formattedOpenedLabel}`}</Text>
        </View>
        <View row>
          <View style={{ justifyContent: "flex-end", alignItems: "flex-end" }}>
            <Text variant="heading1">
              {moneyToFormattedString(item.saleSummary.totalSales)}
            </Text>
            <Text variant="heading4" color="subdued">
              Total sales
            </Text>
          </View>
          <View centerV>
            <Text text50>
              <AntDesign
                style={{ marginLeft: Spacings.s4, color: colors.Text }}
                name="right"
                size={24}
              />
            </Text>
          </View>
        </View>
      </View>
    </Pressable>
  );
};
